<template>
  <div class="main">
    <div class="rubrica-box">
      <div class="search-box">
        <i class="rds-icon rds-icon-search"></i>
        <input
          ref="input"
          type="text"
          name="cerca"
          placeholder="Cerca contatto"
          v-model="searchString"
          id="input"
        />
      </div>
      <div class="contact-list">
        <ContactCard
          v-bind:userContact="userContact"
          v-for="userContact in filteredContacts"
          v-bind:key="userContact.id"
        ></ContactCard>
      </div>
    </div>
  </div>
</template>
<script>
import ContactCard from '@/components/ContactCard.vue';
import store from '../stores';
import { eventBus } from '../services/EventBus';
export default {
  name: 'rds-contact-list',
  components: {
    ContactCard
  },
  data() {
    return {
      contacts: [],
      searchString: ''
    };
  },
  computed: {
    filteredContacts: function() {
      let fc = this.contacts // eslint-disable-line vue/no-side-effects-in-computed-properties
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        })
        .filter(
          c =>
            c.name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1
        );
      return fc;
    }
  },
  methods: {
    backButtonClicked() {
      this.searchString = '';
    }
  },
  watch: {
    searchString: function(val, oldVal) {
      if (val.length > 0 && oldVal.length === 0) {
        eventBus.$emit('showBackButton');
      } else if (val.length === 0) {
        eventBus.$emit('hideBackButton');
      }
    }
  },
  mounted() {
    this.$refs.input.oninput = e => {
      if (e.inputType === 'insertCompositionText' && !!e.data) {
        this.searchString = e.data;
      } else if (e.inputType === 'insertCompositionText' && e.data === null) {
        this.searchString = '';
      }
    };
    eventBus.$emit('updating');
    store.getAll('rdsUser').then(data => {
      this.contacts = data;
      eventBus.$emit('updated');
    });
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('Rubrica back');
      this.backButtonClicked();
    });
  },
  destroyed() {
    eventBus.$emit('hideBackButton');
    eventBus.$off('backButtonClicked');
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  margin-bottom: 21px;
  flex-direction: row-reverse;
  position: sticky;
  top: 0;
}
.rubrica-box {
  display: flex;
  flex-direction: column;
}
.contact-box.open .contact-image {
  padding: 10px 0;
}
</style>
